import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import Pedidos from '../DetallePedido';
import EditarFechas from './EditarFechas';
import formatMoney from '../../../utils/formatMoney';
import getListaBonos from '../../../utils/getListaBonos';
import showModals from './showModals';
import { FadeLoader } from 'react-spinners';
import { fetchFacturacion,fetchPedidosColores,fetchPedidosUso,fetchProformaColor,fetchProformas,imprimirProforma,imprimirEstadoPrecios} from '../../../actions';
import { FETCH_PEDIDOS_COLORES,FETCH_PEDIDOS_USO,FETCH_PROFORMA_COLOR,FETCH_FACTURACION } from '../../../actions';
import _ from 'lodash';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import b64toBlob from 'b64-to-blob';


const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE='2';
const CON_PAGINACION='N';
const PAGINA='1';
const NUMERO_PAGINAS='10';
const VAR_VACIO = '';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL='0';
//const ESTADO_PEDIDO_ASIGNADO = 'ASIGNADO';

const PROFORMA_URL = process.env.REACT_APP_SID_PROFORMA;

class ProformaCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editarFechas: false,
      pedidosConCheck: [],
      pedidosNurConCheck: [],
      modalOpen: '',
      muestraLoad:'none',
      pedidosClienteFacturacion:[],
      flagActionTab:'dropdown',
      codMonedaBono:props.fdv.codMonedaFichaVtaVeh,//Req. 92293 ebarboza 26 07 2021
      pedidosColorUso:false,
      pedidosColorUsoVieneDe:'',
      pedidosColorUsoIdUso:'',
      pedidosColorUsoTieneColorUsoDistintos:'',
      pedidosColorUsoColores:[],
      selectPedidosPreasignados:[],
      indSelectAll:0,
      ordersColorsList:[],
      allUseOrdersFV:[],
      listaBonosXproforma:[],
      listaPedidosXProforma:[],
      listaSelecedBonos:[],
      listaSeleceCortesia:[],
      flagBonos:'AgregarBonos',
      activeFilterPedido:props.activeFilterPedido,
      listaCorreos:props.listaCorreos//Req 92528 ebarboza 30 08 2021

    };
  }
  componentDidMount() {
    this.renderLoad();
  }

  fnLimpiarPedidosConCheck=()=>{
    this.setState({pedidosConCheck:[]})
  }

  changeFlagBonos=(flagBonos)=>{
    this.setState({flagBonos:flagBonos})
  }

  fnUnSelectedAll = () => {
    this.setState({ indSelectAll: 0 })
    this.props.changeIndex(this.props.activeFilterPedido);
  }

  traerFacturacion = () =>{
    this.props.loading('block');
    this.props.fetchFacturacion(this.props.fdvID, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE, CON_PAGINACION, PAGINA, NUMERO_PAGINAS)
    .then((result) => {
      if (result.payload.data.estadoTrama === '1') {
        const ped = result.payload.data.listado
        .filter(element => element.numPedidoVeh.split(' ').filter(z => this.state.pedidosConCheck.filter(y => y === z).length !== 0).length !== 0);

        this.setState({
          pedidosClienteFacturacion: ped.map((row) => {
            const numPedidos = row.numPedidoVeh.split(' ').filter(z => this.state.pedidosConCheck.filter(y => y === z).length !== 0);
            return {
              'numPedidoVeh': numPedidos,
              'codClie': row.codClie,
              'desClie': row.desClie,
              'rucClie': row.rucClie,
              'dniClie': row.dniClie,
              'desFormPago': row.desFormPago,
              'desPropietarioVeh': row.desPropietarioVeh,
              'desTipoDoc': row.desTipoDoc,
              'desUsuarioVeh': row.desUsuarioVeh,
              'entidadFinancieraProf': row.entidadFinancieraProf,
              'nomUsuarioSolFact': row.nomUsuarioSolFact,
              'tipoSolFact': row.tipoSolFact,
              'codProv': row.codProv,
              'codCIA': row.codCIA,
              'numProfVeh':row.numProfVeh,
              'estadoTransitoFact':row.estadoTransitoFact
            };
          })
        });

        this.props.loading('none');
      }
    }).catch(error => console.log(error));
  }


    renderLoad = () => {
      getListaBonos(this.props.fdvID,'P').then((result) => {
        this.setState({listaBonosXproforma:result.data.bonos,
                       listaPedidosXProforma:result.data.bonosPedidos,
                       listaSelecedBonos:[],
                       listaSeleceCortesia:[]
                      });

      getListaBonos(this.props.fdvID,'C').then((result) => {
          this.setState({listaBonoXCortesia:result.data.bonos,
                        listaPedidosXCortesia:result.data.bonosPedidos,
                        listaSelecedBonos:[],
                        listaSeleceCortesia:[]});
                      });

          this.traerColorUso();

      });



    }

    traerColorUso = () =>{



       this.props.loading('block');

        const promises = [];
        let allColorsOrdersFV = [];
        let allColorsProformaFV = [];
        let allUseOrdersFV = [];
        let nurPedidos = [];

        let ordersColorsList = [];
        let orderColors = [];

        //colores de pedidos
        promises.push(this.props.fetchPedidosColores(this.props.fdvID, VAR_VACIO));
        promises.push(this.props.fetchPedidosUso(this.props.fdvID, VAR_VACIO));
        //colores de proformas
        promises.push(this.props.fetchProformaColor(this.props.fdvID,this.props.proforma.numProfVeh));
        promises.push(this.props.fetchProformas(this.props.fdvID,this.props.proforma.numProfVeh));
        promises.push(this.props.fetchFacturacion(this.props.fdvID, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL, CON_PAGINACION, VAR_VACIO, VAR_VACIO));

        Promise.all(promises)
            .then((results) => {

              allColorsOrdersFV = results.filter(element => element.type === FETCH_PEDIDOS_COLORES)
                .map(row => row.payload.data.colorPedidoList)[0];
              allColorsProformaFV = results.filter(element => element.type === FETCH_PROFORMA_COLOR)
                .map(row => row.payload.data.colorProforma)[0];

              allUseOrdersFV = results.filter(element => element.type === FETCH_PEDIDOS_USO)
                .map(row => row.payload.data.usoPedidoLista)[0];

              allUseOrdersFV = results.filter(element => element.type === FETCH_PEDIDOS_USO)
                .map(row => row.payload.data.usoPedidoLista)[0];

              nurPedidos = results.filter(element => element.type === FETCH_FACTURACION)
                .map(row => row.payload.data.listado)[0];

              let indexColor = 0;

              nurPedidos.forEach(result => {

                orderColors = allColorsOrdersFV.filter(entry => parseInt(entry.nurFichaVtaPedido,10)===parseInt(result.nurFichaVtaPedido,10));
                if(orderColors.length>0)
                    ordersColorsList.push(
                      {'nurFichaVtaPedido':result.nurFichaVtaPedido,'numPedidoVeh':result.numPedidoVeh,'orderColors':orderColors.map((entry,index) => Object.assign({},entry,{id:index})),'status':1}
                    )
                else{
                    ordersColorsList.push(
                      {'nurFichaVtaPedido':result.nurFichaVtaPedido,'numPedidoVeh':result.numPedidoVeh,'orderColors':allColorsProformaFV.map((entry,index) => Object.assign({},entry,{id:index})),'status':0}
                    )
                }
              })

              this.setState({allUseOrdersFV:allUseOrdersFV})
              this.setState({ordersColorsList:ordersColorsList})
              this.setState({pedidosColorUso:true});
              this.props.loading('');

            });


      }


  traerEquipos = () =>{

  }

  openEdit = () => this.setState({ editarFechas: true })
  closeEdit = () => this.setState({ editarFechas: false })


  getCliente = (item) =>{
    let pedido = [];
    pedido = _.filter(this.props.pedidos, _.property(this.props.proformaSeleccionada))[0][this.props.proformaSeleccionada];
    return pedido.filter((obj) => obj.numPedidoVeh === item)
  }

  selectAll = () => {

        if(this.props.indSelectAll%2 === 0){

            const pedidos = _.filter(this.props.pedidos, _.property(this.props.proforma.numProfVeh))[0][this.props.proforma.numProfVeh]
            let selectPedidosPreasignados=[];
            let pedidosConCheck=[];
            let pedidosNurConCheck = [];
            let nurPedido = '';

            pedidos.forEach(data => {

              if(this.getCliente(data.numPedidoVeh).length === 1){

                if(selectPedidosPreasignados.indexOf(data.numPedidoVeh)>=0){
                  selectPedidosPreasignados = selectPedidosPreasignados.filter(it => it !== data.numPedidoVeh);
                }else{
                  selectPedidosPreasignados = [...selectPedidosPreasignados, data.numPedidoVeh]
                }
              }

              if (pedidosConCheck.indexOf(data.numPedidoVeh)>=0) {
                pedidosConCheck = pedidosConCheck.filter(it => it !== data.numPedidoVeh);
                pedidosNurConCheck = pedidosNurConCheck.filter(it => it.nurPedido !== nurPedido);
              } else {
                pedidosConCheck = [...pedidosConCheck, data.numPedidoVeh];
                pedidosNurConCheck = [...pedidosNurConCheck, {'pedido':data.numPedidoVeh,'nurPedido':nurPedido}];
              }

            })

            this.props.fnPedidosConCheck(pedidosConCheck);
            this.setState({ pedidosConCheck: pedidosConCheck });
            this.setState({ pedidosNurConCheck: pedidosNurConCheck });
            this.setState({selectPedidosPreasignados:selectPedidosPreasignados});

      }else {

            this.props.fnPedidosConCheck([]);
            this.setState({ pedidosConCheck: [] });
            this.setState({ pedidosNurConCheck: [] });
            this.setState({selectPedidosPreasignados:[]});
      }

      this.setState({indSelectAll:this.state.indSelectAll+1})
      this.props.fnChangeindSelectAll();

  }

  clearVariablechangeIndex = (items) =>{
    this.setState({ pedidosConCheck: [] });
    this.setState({ pedidosNurConCheck: [] });
    this.setState({selectPedidosPreasignados:[]});
    this.props.fnChangeIndInitialize();
    this.props.changeIndex(items);

  }


  selectCheckPedidos = (pedido,nurPedido) => {
    const { pedidosConCheck,pedidosNurConCheck,selectPedidosPreasignados } = this.state;
    this.props.loading('')
    if(this.getCliente(pedido).length === 1){
      if(selectPedidosPreasignados.indexOf(pedido)>=0){
        this.setState({ selectPedidosPreasignados: selectPedidosPreasignados.filter(it => it !== pedido) });
      }else{
        this.setState({selectPedidosPreasignados:[...selectPedidosPreasignados, pedido]});
      }
    }

    if (pedidosConCheck.indexOf(pedido)>=0) {
      this.setState({ pedidosConCheck: pedidosConCheck.filter(it => it !== pedido) });
      this.setState({ pedidosNurConCheck: pedidosNurConCheck.filter(it => it.nurPedido !== nurPedido) });
      this.props.fnPedidosConCheck(pedidosConCheck.filter(it => it !== pedido));
    } else {
      this.setState({ pedidosConCheck: [...pedidosConCheck, pedido] });
      this.setState({ pedidosNurConCheck: [...pedidosNurConCheck, {'pedido':pedido,'nurPedido':nurPedido}] });
      this.props.fnPedidosConCheck([...pedidosConCheck, pedido]);
    }
  }

  openModal = (nomModal) => {
    if(nomModal==='SolicitarFacturacion'){
      this.traerFacturacion();
    } else if(nomModal==='AplicarColorUso'){
      this.traerColorUso();
    }
    this.setState({ modalOpen: nomModal })
  }

  closeModal = () =>{
    this.setState({ modalOpen: '' });
    this.setState({
      pedidosColorUso:false,
      pedidosColorUsoVieneDe:'',
      pedidosColorUsoIdUso:'',
      pedidosColorUsoTieneColorUsoDistintos:'',
      pedidosColorUsoColores:[],
    });
    this.clearCheck();
  }

 clearCheck = () =>{
   this.setState({pedidosConCheck:[],selectPedidosPreasignados:[]});
 }
//Inicio Req. 86268 - Soporte legados- función que abre la proforma en un nuevo tab
onClickDescargarProforma =(numProformaVeh) => {
  console.log("numProformaVeh",numProformaVeh);
  this.setState({muestraLoad: 'block'});
  this.props.imprimirProforma(numProformaVeh).then((result) => {
      if (result.payload.data.estadoTrama === "1") {
          const nombrePdf = "Proforma-"+numProformaVeh;
          const b64Data = result.payload.data.reporteProformaPdf;

          // Convirtiendo la data b64Data a blob
          const blob = b64toBlob(b64Data.replace(/\s/g, ''));
            //Creando un Blob desde PDF Stream
            const file = new Blob(
              [blob],              
              {type: 'application/pdf'}
              );

            //Construyendo un objeto URL desde el blob object
              const fileURL = URL.createObjectURL(file);      
            //Abriendo la url en una nueva ventana
             window.open(fileURL);


             this.setState({muestraLoad: 'none'});
      } 
  }).catch(() => {
      this.setState({muestraLoad: 'none'});
     
  });
}

onClickDescargarEstadoPrecios =(numProformaVeh) => {
  this.setState({muestraLoad: 'block'});
  this.props.imprimirEstadoPrecios(numProformaVeh).then((result) => {
      if (result.payload.data.estadoTrama === "1") {
          const nombrePdf = "EstructuraPrecios";
          const b64Data = result.payload.data.reporteProformaPdf;

          // Convirtiendo la data b64Data a blob
          const blob = b64toBlob(b64Data.replace(/\s/g, ''));
            //Creando un Blob desde PDF Stream
            const file = new Blob(
              [blob],              
              {type: 'application/pdf'}
              );

            //Construyendo un objeto URL desde el blob object
              const fileURL = URL.createObjectURL(file);      
            //Abriendo la url en una nueva ventana
             window.open(fileURL);


             this.setState({muestraLoad: 'none'});
      } 
  }).catch(() => {
      this.setState({muestraLoad: 'none'});
     
  });
}
//Fin Req. 86268
//Inicio Req. 90917 - v2
onClickCrearSolicitudCredito =() => {
  window.open(window.location.toString().split('/')[0]+'/venta/proforma/registro/solicitud-credito?cliente='+this.props.fdv.codClie+'&proforma='+this.props.proforma.numProfVeh);
}
//Fin Req. 90917 - v2

  render() {
    const { editarFechas } = this.state;
    return (
      <div key={`${this.props.fdvID}-${this.props.proforma.numProfVeh}`}>
        <div className='card card-plain card-lg'>
          <div className='dropdown kebab card-lg-action customToggle' role='group'>
            <button className='btn dropdown-toggle kebab-btn'>
              <i className='ion-android-more-vertical' />
            </button>
            <ul className='dropdown-menu dropdown-menu-right'>
              {
                this.props.fdvState !== 'V' ?
                  <li onClick={() => this.props.openAlert({ estadoTrama: '0', mensaje: 'El estado de la ficha de venta debe ser vigente' })}><a><i className='ion-model-s mr-2 c-cyan' />
                </a></li> :
                  <li onClick={(e) => this.props.handlePermissions(e,this.props.proforma.numProfVeh) && this.props.openModalPedidos(this.props.proforma)}>
                    <a data-permisos='ind_asignar_pedido'><i className='ion-model-s mr-2 c-cyan' />Asignar pedido</a>
                  </li>
              }
              <li onClick={(e) => this.props.handlePermissions(e,this.props.proforma.numProfVeh) && this.props.openModalDesasignar(this.props.proforma.numProfVeh)}>
                <a data-permisos='ind_eliminar_proforma'><i className='ion-trash-a mr-2 c-cyan' />Eliminar proforma</a>
              </li>
              {/*Inicio Req. 86268 soprte legados*/}
              <li onClick={(e) => this.onClickDescargarProforma(this.props.proforma.numProfVeh)}>
                <a data-permisos='ind_imprimir_proforma'><i className='ion-printer mr-2 c-cyan' />Imprimir proforma</a>
              </li>
              <li onClick={(e) =>this.onClickDescargarEstadoPrecios(this.props.proforma.numProfVeh)}>
                <a data-permisos='ind_imprimir_estprecios'><i className='ion-clipboard mr-2 c-cyan' />Imprimir Est. Precios</a>
              </li>
              {/*Fin Req. 86268 soprte legados*/}
              {/*Inicio Req 90917_L_Absorcion_Legados_Fase_2*/}
              <li onClick={(e) =>this.onClickCrearSolicitudCredito()}> 
                <a data-permisos='ind_crear_soli_prof'><i className='ion-card mr-2 c-cyan' />Crear Solicitud de Créditos</a>
              </li>
              {/*Fin Req 90917_L_Absorcion_Legados_Fase_2*/}
            </ul>
          </div>
          <button className='card-lg-title btn-clean' onClick={() => {this.props.selectProforma(this.props.proforma.numProfVeh);}}>
                  {/*Inicio Req 90917_L_Absorcion_Legados_Fase_2*/}
                  <h3>Proforma - {this.props.proforma.numProfVeh}
                    {this.props.proformaSeleccionada === this.props.proforma.numProfVeh ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />}
                    <a  target="_blank" 
                    href={  this.props.proforma.tipOrigCrea === '3' ? this.props.proforma.rutaSapProforma + this.props.proforma.numProfVeh : window.location.toString().split('/')[0]+'/sidweb/#/venta/proforma/registro/'+this.props.proforma.numProfVeh}
                    style={{marginLeft:10,fontSize:11}}>Ir a proforma</a>
                  </h3>
                  {/*Fin Req 90917_L_Absorcion_Legados_Fase_2*/}
          </button>

          <Panel collapsible expanded={this.props.proformaSeleccionada === this.props.proforma.numProfVeh} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0' }}>
            <div className='row mb-3'>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Familia</p>
                <p>{this.props.proforma.desFamiliaVeh}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Marca</p>
                <p>{this.props.proforma.nomMarca}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Modelo</p>
                <p>{this.props.proforma.desBaumuster}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Cant. unid.</p>
                <p>{this.props.proforma.canVeh}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Carrocero.</p>
                <p>{this.props.proforma.proveedorCarrocero}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Año de Fabricación</p>
                <p>{this.props.proforma.anoFabricacionVeh}</p>
              </div>
            </div>
            <div className='row'>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Venta</p>
                <p>{this.state.codMonedaBono === 'DOL' ? 'US$' : 'S/'}{formatMoney(this.props.proforma.valVtaVeh)}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Dscto.</p>
                <p>{this.state.codMonedaBono === 'DOL' ? 'US$' : 'S/'}{formatMoney(this.props.proforma.valDesc)}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Valor (venta-dscto)</p>
                <p>{this.state.codMonedaBono === 'DOL' ? 'US$' : 'S/'}{formatMoney(this.props.proforma.valNeto)}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Total x unidad</p>
                <p>{this.state.codMonedaBono === 'DOL' ? 'US$' : 'S/'}{formatMoney(this.props.proforma.valPreVeh)}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>Total Venta</p>
                <p>{this.state.codMonedaBono === 'DOL' ? 'US$' : 'S/'}{formatMoney(this.props.proforma.total)}</p>
              </div>
              <div className='col-xs-12 col-md-2'>
                <p className='labelInfo'>SKU</p>
                <p>{this.props.proforma.skuSap}</p>
              </div>
            </div>
            {
                !editarFechas ?
                  <Pedidos
                    pedidos={this.props.pedidosXfichaVenta}
                    numProfVeh={this.props.proforma.numProfVeh}
                    openModal={this.openModal}
                    selectCheckPedidos={this.selectCheckPedidos}
                    pedidosConCheck={this.state.pedidosConCheck}
                    openEdit={this.openEdit}
                    handleClick={this.props.handleClick}
                    activeFilterPedido={this.props.activeFilterPedido}
                    changeIndex={this.clearVariablechangeIndex}
                    selectPedidosPreasignados={this.state.selectPedidosPreasignados}
                    selectAll={this.selectAll}
                    loading={this.props.loading}
                    openAlert={this.props.openAlert}
                    reload={this.reload}
                    fdvID = {this.props.fdvID}
                    handlePermissionsMassive={this.props.handlePermissionsMassive}
                    isFinishedAsignacionDefinitiva={this.props.isFinishedAsignacionDefinitiva}
                    doneAsignacionDefinitiva={this.props.doneAsignacionDefinitiva}
                    listaCorreos={this.state.listaCorreos}//Req 92528 ebarboza 30 082021
                  />
                :
                  <EditarFechas
                    pedidos={this.props.pedidos}
                    closeEdit={this.closeEdit}
                    numProfVeh={this.props.proforma.numProfVeh}
                    selectCheckPedidos={this.selectCheckPedidos}
                    pedidosConCheck={this.state.pedidosConCheck}
                  />
              }
          </Panel>
        </div>
        { showModals(this.state.modalOpen,this) }

        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
  };
}
export default connect(
  mapStateToProps,
  { fetchFacturacion,fetchPedidosColores,fetchPedidosUso,fetchProformaColor,fetchProformas,imprimirProforma,imprimirEstadoPrecios }
)(ProformaCard);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/ContenidoTablas/ProformaCard.js